import { h, Component } from 'preact'
import DynamicImport from '../utils/DynamicImport'
const CodeMirror = DynamicImport(async () => await import('../../control-components/codemirror/index'))

const DEFAULT_CSS = '/* Note: We recommend inviting a \nprofessional web developer to work with \nCustom Css. Test your code on a staging \nenvironment before publishing. */'

interface Props {
  content: string
  onUpdate: (updatedCustomCss: string) => void
}

export default class CustomCss extends Component<Props> {
  constructor (props: Props) {
    super(props)

    props.content = props.content || DEFAULT_CSS

    this.handleChange = this.handleChange.bind(this)
  }

  handleChange (data: string) {
    this.props.onUpdate(data)
  }

  render ({ content }: Props) {
    return (
      <div class='customCss box__pad'>
        <CodeMirror
          defaultValue={content}
          onChange={this.handleChange}
        />
      </div>
    )
  }
}
